import { useState, useEffect, useRef } from 'react'

// Lista com caixinhas para os filtros avancados (Acompanhamento de Propostas, Apolices): mais de
// uma opcao pode ser marcada; nenhuma marcada = todas. opcoes: [{ valor, label }].
export default function SelecaoMultipla({ label, opcoes, valores, onChange }) {
  const [aberto, setAberto] = useState(false)
  const ref = useRef(null)
  useEffect(() => {
    if (!aberto) return
    const fechar = (e) => { if (ref.current && !ref.current.contains(e.target)) setAberto(false) }
    document.addEventListener('mousedown', fechar)
    return () => document.removeEventListener('mousedown', fechar)
  }, [aberto])
  const rotulo = (v) => opcoes.find(o => o.valor === v)?.label || v
  const resumo = !valores.length ? 'Todos' : valores.length <= 2 ? valores.map(rotulo).join(', ') : `${valores.length} selecionados`
  const alternar = (v) => onChange(valores.includes(v) ? valores.filter(x => x !== v) : [...valores, v])
  return (
    <div className="form-group" style={{ marginBottom: 0, position: 'relative' }} ref={ref}>
      <label className="form-label">{label}</label>
      <button type="button" className="form-select" onClick={() => setAberto(a => !a)}
        style={{ width: '100%', textAlign: 'left', cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: valores.length ? '#1A1A2E' : '#888' }}>
        {resumo}
      </button>
      {aberto && (
        <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, minWidth: '100%', zIndex: 30, background: '#fff', border: '1px solid #D9DDE3', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', maxHeight: 280, overflowY: 'auto', padding: '4px 0' }}>
          {opcoes.length === 0 && <div style={{ padding: '8px 12px', fontSize: 13, color: '#888' }}>Nenhuma opção</div>}
          {opcoes.map(o => (
            <label key={o.valor} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
              <input type="checkbox" checked={valores.includes(o.valor)} onChange={() => alternar(o.valor)} style={{ accentColor: 'var(--primary)' }} />
              {o.label}
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
